// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ArticlePagination_pagination__iQlan"};